export default {
  SERVICECENTERS_LIST: "Liste des centres de service",
  ADD_SERVICECENTER: "Ajouter un centre de service",
  SERVICECENTER_ADDED: "Centre de service ajouté",
  EDIT_SERVICECENTER: "Modifier un centre de service",
  SERVICECENTER_UPDATED: "Centre de service mis à jour",
  DELETE_THIS_SERVICECENTER: "Supprimer ce centre de service ?",
  SERVICECENTER_DELETED: "Centre de service supprimé",
};
